/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const TRANSACTION_RENTAL = 'L'
export const TRANSACTION_SALE = 'V'
export const TRANSACTION_SEASONAL_RENTAL = 'S'

export const TransactionCodes = [
  TRANSACTION_RENTAL,
  TRANSACTION_SALE,
  TRANSACTION_SEASONAL_RENTAL
]
